// extracted by mini-css-extract-plugin
export default {"productList":"GgYJU1i9PObr0S2gbA9N-ProductList-productList"};